import { Producto } from "./producto";
import { Lote } from "./lote";
import { Serie } from "./serie";
import { SerieMovimiento } from "./SerieMovimiento";

export class CompraDetalle{
    public constructor(
        public id: String = "",
        public cantidad: number = 0,
        public descripcion: String = "",
        public codigo: String = "",
        //public producto: String = "",
        public producto: Producto = new Producto(),
        public unidad: String = "",
        public precio_unitario: number = 0,
        public lote : Lote = new Lote(),
        public series: Array<any> = [],
        public codigos_series: Array<string> = [],
        // public es_servicio: boolean = false,
        public tipo_producto_id: string = "",
        public if_uso_lote:boolean = false,
        public desc_valor: number = 0,
        //public desc_porcent: number = 0,

        public subtotal: number = 0,
        public iva:number = 0,
        public total: number = 0,
        public graba_iva: boolean = false,
        public detalle: String = "",
        public compra_id: String = "",
        public producto_id: String = "", 
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public usuario_id:String = null,

        public cuenta_ingreso_id: String = "",
        public cuenta_inventario_id: String = "",
        public cuenta_costo_gasto_id: String = "",
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/compra_detalle.ts